import React from "react";
import './tooltip.css';
import info from '../../../../SharedAssets/info.svg'

export const CashflowVsExpense = () => {

    return (
    <div className='tooltipInfo'>
        <img src={info} />
        <p className='primaryLabel primaryTitle'>Can you live off your property income?</p>
        <div className='content bodyTextBlue'>
            <p>Getting to a place where you can comfortable live off your property income is ideal. You basically can retire at that point. </p>
            <br />
            <p>To do this, you need to make sure that your properties are producing enough cash flow to cover your personal expenses.</p>
            <br />
            <p>Although managing your personal expenses is NOT the purposes of WayBoz, we've set it up so you can easily add your personal incomes and expenses as desired.</p>
            <br />
            <p className='secondaryLabelBlue'>Here's the great part!</p>
            <br />
            <p>If you do choose to include your personal expenses in WayBoz, simply look at the "Property Cash Flow vs Personal Expenses" chart (where you just clicked).</p>
            <br />
            <p> If the dashed green line (your average property cash flow) is above the dashed red line (your average personal expenses) then congrats - your at a place where your properties are cash flowing enough to cover your personal expenses!</p>
            <br />

        </div>
    </div>
    )

}